<p-dialog
  header="Import from WellCat (.edm.xml)"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="{ width: '560px' }"
  [closable]="!isImporting()">

  @if (!importResult()) {
    <div class="flex flex-col gap-4 py-2">
      <p-message severity="info" styleClass="w-full">
        <span class="text-sm">ℹ️ Make sure you have created and switched to the PERIFOR design you want to populate before importing. <br>⚠️ Selected categories will overwrite corresponding data in the active PERIFOR design.</span>
      </p-message>

      <div class="flex flex-col gap-1">
        <label class="font-medium" for="wellcat-file">EDM XML file</label>
        <input
          id="wellcat-file"
          type="file"
          accept=".xml,.edm.xml,text/xml,application/xml"
          (change)="onFileSelected($event)">
        @if (selectedFile(); as file) {
          <div class="text-xs text-gray-600 dark:text-gray-300">
            Selected: {{ file.name }}
          </div>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label class="font-medium">Import Categories</label>
        <div class="flex flex-col gap-2 pl-1">
          <div class="flex items-center gap-2">
            <p-checkbox
              inputId="wcImportTrajectory"
              [ngModel]="importTrajectory()"
              (ngModelChange)="importTrajectory.set($event)"
              [binary]="true">
            </p-checkbox>
            <label for="wcImportTrajectory">Trajectory</label>
          </div>

          <div class="flex items-center gap-2">
            <p-checkbox
              inputId="wcImportWellboreGeometry"
              [ngModel]="importWellboreGeometry()"
              (ngModelChange)="importWellboreGeometry.set($event)"
              [binary]="true">
            </p-checkbox>
            <label for="wcImportWellboreGeometry">Well Configuration</label>
          </div>

          <div class="flex items-center gap-2">
            <p-checkbox
              inputId="wcImportFormationMarkers"
              [ngModel]="importFormationMarkers()"
              (ngModelChange)="importFormationMarkers.set($event)"
              [binary]="true">
            </p-checkbox>
            <label for="wcImportFormationMarkers">Formation Tops</label>
          </div>

          <div class="flex items-center gap-2">
            <p-checkbox
              inputId="wcImportPressureWindow"
              [ngModel]="importPressureWindow()"
              (ngModelChange)="importPressureWindow.set($event)"
              [binary]="true">
            </p-checkbox>
            <label for="wcImportPressureWindow">Pressure Window (PPFG)</label>
          </div>

          <div class="flex items-center gap-2">
            <p-checkbox
              inputId="wcImportTemperature"
              [ngModel]="importTemperature()"
              (ngModelChange)="importTemperature.set($event)"
              [binary]="true">
            </p-checkbox>
            <label for="wcImportTemperature">Temperature</label>
          </div>
        </div>
      </div>
    </div>
  }

  @if (importResult(); as result) {
    <div class="flex flex-col gap-3 py-2">
      <p-message severity="success" styleClass="w-full">
        <span class="text-sm">{{ result.summary }}</span>
      </p-message>

      @if (result.report; as report) {
        @if (report.applied.length > 0) {
          <div class="flex flex-col gap-1">
            <div class="font-medium">✅ Applied</div>
            @for (item of report.applied; track item.category + item.message) {
              <div class="text-sm">[{{ item.category }}] {{ item.message }}</div>
            }
          </div>
        }

        @if (report.reviewRequired.length > 0) {
          <div class="flex flex-col gap-1">
            <div class="font-medium">⚠️ Review recommended</div>
            @for (item of report.reviewRequired; track item.category + item.message) {
              <div class="text-sm">[{{ item.category }}] {{ item.message }}</div>
            }
          </div>
        }

        @if (report.actionRequired.length > 0) {
          <div class="flex flex-col gap-1">
            <div class="font-medium">✏️ Action required</div>
            @for (item of report.actionRequired; track item.category + item.message) {
              <div class="text-sm">[{{ item.category }}] {{ item.message }}</div>
            }
          </div>
        }

        @if (report.notImported.length > 0) {
          <div class="flex flex-col gap-1">
            <div class="font-medium">ℹ️ Not imported</div>
            @for (item of report.notImported; track item.category + item.message) {
              <div class="text-sm">[{{ item.category }}] {{ item.message }}</div>
            }
          </div>
        }
      }
    </div>
  }

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      @if (importResult()) {
        <p-button
          label="Copy report"
          icon="pi pi-copy"
          severity="secondary"
          [outlined]="true"
          (onClick)="copyReport()">
        </p-button>
        <p-button
          label="Close"
          icon="pi pi-check"
          (onClick)="close()">
        </p-button>
      } @else {
        <p-button
          label="Import"
          icon="pi pi-upload"
          [disabled]="!canImport() || isImporting()"
          [loading]="isImporting()"
          (onClick)="import()">
        </p-button>
        <p-button
          label="Cancel"
          icon="pi pi-times"
          severity="danger"
          [outlined]="true"
          [disabled]="isImporting()"
          (onClick)="close()">
        </p-button>
      }
    </div>
  </ng-template>
</p-dialog>
